import { BaseHTTPClient } from '../api/http-client.service';
import { APIType } from '../api/configuration';
import { ApiConfig } from '../api/api-service/api-config.model';

export class ReportLibraryService extends BaseHTTPClient {
    public static async getReportLibrary(payload: any) {
        return this.sendToGateway({
            url: `${process.env.REACT_APP_API_URL}/reports`,
            method: APIType.GET
        });
    }
    public static async saveReport(payload: any) {
        return this.sendToGateway({
           url: `${process.env.REACT_APP_API_URL}/reports/save`,
           method: APIType.POST,
           data: payload
        });
    }
    public static async deleteReport(payload: any) {
        return this.sendToGateway({
           url: `${process.env.REACT_APP_API_URL}/reports_id`,
           method: APIType.DELETE,
           data: payload,
        });
    }
    public static async downloadReport(params: any) {
    // X-User-Email removed: identity is derived from the JWT server-side.
    const response = await fetch(`${process.env.REACT_APP_API_URL}/report/download`, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sessionStorage.getItem('idToken')}`,
        'X-Tenant-ID': sessionStorage.getItem('tenant') ? JSON.parse(sessionStorage.getItem('tenant') || '{}').TenantId : '',
      },
      method: "POST",
      body: JSON.stringify(params),
    });

    if (!response.ok) {
      throw new Error('Failed to download report');
    }

    const disposition = response.headers.get('content-disposition');
    const filenameMatch = disposition?.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
    const filename = filenameMatch ? filenameMatch[1].replace(/['"]/g, '').trim() : null;

    const data = await response.arrayBuffer();
    return { data, filename };
  }
}
